export const difficulty = (level: number): number[] => {
  switch (level) {
    case 1:
      return [1, 5]

    case 2:
      return [1, 10]

    case 3:
      return [6, 12]

    default:
      return [1, 10]
  }
}
